export default "__VITE_ASSET__eb9153a1__"